import React from 'react';
import {
  Avatar,
  Box,
  CardContent, CardHeader,
  Chip,
  Divider,
  List, ListItem, ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Typography
} from '@material-ui/core';
import {
  Build as BuildIcon,
  Store as StoreIcon,
} from '@material-ui/icons';
import { useState } from 'react';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    backgroundColor: theme.palette.grey[100],
    padding: '8px 16px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '4px',
    marginTop: theme.spacing(2)
  },
  hizmetHeader: {
    backgroundColor: '#424242',
    color: '#FF9800',
    padding: '6px 12px',
    borderRadius: '8px 8px 0 0',
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  itemBox: {
    borderLeft: '4px solid #FF9800',
    marginBottom: '2px',
    backgroundColor: '#fafafa'
  },
  priceTag: {
    fontWeight: 'bold',
    color: '#424242'
  },
  avatarH: { backgroundColor: '#FF9800', color: '#fff' },
  avatarI: { backgroundColor: '#2196F3', color: '#fff', width: 30, height: 30, fontSize: '0.8rem' },
  avatarM: { backgroundColor: '#4CAF50', color: '#fff', width: 30, height: 30, fontSize: '0.8rem' },
}));

// Alt Fonksiyon: Özet Satırı (Props kontrolü eklendi)
const SummaryRow = ({ title, icon: Icon, value, subValue }) => {
  const classes = useStyles();
  return (
    <List disablePadding>
      <ListItem className={classes.itemBox}>
        <ListItemAvatar>
          <Avatar variant="rounded" style={{ backgroundColor: '#e0e0e0', color: '#FF9800' }}>
            {Icon ? <Icon /> : <BuildIcon />}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={<Typography variant="subtitle2">{title}</Typography>}
          secondary={
            <Typography variant="body2" color="textPrimary" style={{ fontWeight: 600 }}>
              {value || 'Bilgi Yok'}
            </Typography>
          }
        />
        {subValue && <Chip label={subValue} size="small" variant="outlined" />}
      </ListItem>
    </List>
  );
};

function SonlandirOzet() {
  const classes = useStyles();
  // loadBaslandiJob sonucu boş dönebilir, güvenli hale getirelim
  const [job] = useState(() => {
      const data = loadBaslandiJob();
      return (data && data.length > 0) ? data[0] : null;
  });


  // Veri yoksa hata vermek yerine kullanıcıya bilgi verelim
  if (!job) {
    return (
        <Box p={3} textAlign="center">
            <Typography color="error">Görüntülenecek aktif bir iş verisi bulunamadı.</Typography>
        </Box>
    );
  }

  // Fiyat formatlama yardımcısı (toFixed hatalarını önler)
  const formatPrice = (price) => {
      const num = parseFloat(price);
      return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  return (
    <Box>
      <Divider />
      <CardHeader
        title={<Typography variant="h6">Fiş Özeti</Typography>}
        style={{ textAlign: 'center' }}
      />
      <Divider />

      <CardContent style={{ padding: '8px' }}>
        {/* Ürün Bilgisi */}
        <SummaryRow
          title="Ürün Bilgisi"
          icon={BuildIcon}
          value={job?.MODEL}
          subValue={job?.KUL_MODEL_KODU}
        />

        {/* Bayi Bilgisi */}
        <SummaryRow
          title="Bayi"
          icon={StoreIcon}
          value={job?.BAYI_ACIKLAMA}
          subValue={(job?.BAYI_KODU !== "0" && job?.BAYI_KODU !== null) ? job?.BAYI_MARKA : null}
        />

        {/* Hizmetler, İşçilikler ve Malzemeler Safe Map */}
        {(job?.HIZMETLER || []).map((h, index) => {
          // Filter işlemleri öncesi dizilerin varlığını kontrol ediyoruz
          const iscilikler = (job?.ISCILIKLER || []).filter(i => i.HIZMET_KODU === h.HIZMET_KODU);
          const malzemeler = (job?.MALZEMELER || []).filter(m => m.HIZMET_KODU === h.HIZMET_KODU);

          return (
            <Box key={index} mb={3}>
              <div className={classes.hizmetHeader}>
                <Typography variant="subtitle2" style={{ color: '#FF9800' }}>
                  Hizmet: {h?.KUL_HIZMET_KODU ?? '---'}
                </Typography>
                <Typography variant="caption" style={{ color: '#FF9800' }}>
                    {h?.ACIKLAMA ?? ''}
                </Typography>
              </div>

              <List disablePadding>
                {/* İşçilikler */}
                {iscilikler.map((i, idx) => (
                  <ListItem divider key={`i-${idx}`}>
                    <ListItemAvatar>
                      <Avatar className={classes.avatarI}>İ</Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={i?.ACIKLAMA || 'İşçilik Tanımı Yok'}
                      secondary={i?.KUL_ISCILIK_KODU}
                    />
                    <ListItemSecondaryAction>
                      <Typography className={classes.priceTag}>
                        {i?.KUL_ISCILIK_KODU === '880'
                          ? `${formatPrice(job?.DEZENFEKSIYON_TUTAR)}₺`
                          : `${formatPrice(i?.FIYAT)}₺`}
                      </Typography>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}

                {/* Malzemeler */}
                {malzemeler.map((m, idx) => (
                  <ListItem divider key={`m-${idx}`}>
                    <ListItemAvatar>
                      <Avatar className={classes.avatarM}>M</Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={m?.ACIKLAMA || 'Malzeme Tanımı Yok'}
                      secondary={`${m?.MALZEME_STOK_NO ?? ''} (${m?.ADET || 1} Adet)`}
                    />
                    <ListItemSecondaryAction>
                      <Typography className={classes.priceTag}>
                        {formatPrice(m?.FIYAT)}₺
                      </Typography>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            </Box>
          );
        })}
      </CardContent>
    </Box>
  );
}

export default SonlandirOzet;